/**
 * Settings Services 
 */

import api from './api-wrapper';

const SETTINGS_BASE = '/api/v1/accounts';
const SETTINGS_V3_WHITELABEL = '/api/v3/whitelabel';
const SETTINGS_V3_PROFILE = '/api/v3/profile';
/**
 * Helper to extract response when it is needed
 */
const unwrapResponse = (response) => response?.response ?? response;

// Change user avatar/profile image
export const changeAvatar = (image) => {
  const formData = new FormData();
  formData.append('profile_image', image);
  return api.put(`${SETTINGS_BASE}/profile/image/`, formData).then(unwrapResponse);
};

// update whitelabel aspect styles for whitelabel users
export const updateWhitelabelTheme = (themeData) => {
  return api.post(`${SETTINGS_V3_WHITELABEL}/edit-settings/`, themeData).then(unwrapResponse);
}

// get whitelabel logo
export const getLogo = () => {
  return api.get(`${SETTINGS_V3_WHITELABEL}/get-logo/`).then(unwrapResponse);
}

// get whitelabel members
export const getWhitelabelMembers = (data, pagination) => {
  return api.post(`${SETTINGS_V3_WHITELABEL}/members/`, data, { params: pagination }).then(unwrapResponse);
}

// add whitelabel member
export const addWhitelabelMember = (data) => {
  return api.post(`${SETTINGS_V3_WHITELABEL}/add-member/`, data).then(unwrapResponse);
}

// remove whitelabel member
export const removeWhitelabelMember = (data) => {
  return api.post(`${SETTINGS_V3_WHITELABEL}/remove-member/`, data).then(unwrapResponse);
}

export const languajesPlatform = (data) => api.post(`${SETTINGS_V3_PROFILE}/update-language-platform/`, data).then(unwrapResponse);